module.exports = __webpack_public_path__ + "static/media/57-iveco.aa56081b.jpg";